import script from "./CommentEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentEdit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__